import { render, staticRenderFns } from "./NodeTipoNotaPesquisa.vue?vue&type=template&id=0f16f1c2&"
import script from "./NodeTipoNotaPesquisa.vue?vue&type=script&lang=js&"
export * from "./NodeTipoNotaPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
